import { useEffect, useState } from "react";

export type PresencePhase = "entering" | "entered" | "exiting" | "exited";

/** Keeps content mounted long enough for a CSS exit transition to finish. */
export function usePresence(visible: boolean, exitDurationMs: number) {
  const [rendered, setRendered] = useState(visible);
  const [phase, setPhase] = useState<PresencePhase>(visible ? "entering" : "exited");

  useEffect(() => {
    if (visible) {
      setRendered(true);
      setPhase("entering");

      const frame = window.requestAnimationFrame(() => {
        setPhase("entered");
      });
      return () => window.cancelAnimationFrame(frame);
    }

    if (!rendered) return;

    setPhase("exiting");
    const timeout = window.setTimeout(() => {
      setRendered(false);
      setPhase("exited");
    }, exitDurationMs);

    return () => window.clearTimeout(timeout);
  }, [exitDurationMs, rendered, visible]);

  return { rendered, phase };
}
